import React, { CSSProperties, useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';

import ProductionChart from '../../prosumerComponents/charts/productionChart';
import moment from 'moment';

// Datepicker
import DatePicker from "react-datepicker";
import DotLoader from 'react-spinners/DotLoader';
//import { START_DATE } from './common/const';
import { getProductionData } from '../../services/admin.service';


const override: CSSProperties = {
    display: "block",
    margin: "auto",
    marginTop: "250px",
    marginBottom: "200px",
    borderColor: "red",
};


interface ProductionObject {
    startDate: string,
    endDate: string,
    bill: {
        traded: number,
        open_market: number,
        unsold: number
    },
    usage: {
        traded: number,
        open_market: number,
        unsold: number
    }
}


function AdminProduction() {

    const [loading, setLoading] = useState(false);
    const color = "#006837";
    //const auth = JSON.parse(localStorage.getItem('auth')!)
    const [isChecked, setIsChecked] = useState(false);
    const [selectedDate, setSelectedDate] = useState('dst');
    const [startDate, setStartDate] = useState<Date>(() => {
        const date = new Date();
        date.setDate(date.getDate() - 1);
        return date;
    });
    //const dateSelector = 'dst';

    const [productionDayData, setProductionDayData] = useState<ProductionObject[]>([])
    const [productionWeekData, setProductionWeekData] = useState<ProductionObject[]>([])
    const [productionYearData, setProductionYearData] = useState<ProductionObject[]>([])

    const [daykWhDataListTraded, setdaykWhDataListTraded] = useState<any>()

    const [daykWhDataListUnsold, setdaykWhDataListUnsold] = useState<any>()

    const [dayCurrencyDataListTraded, setdayCurrencyDataListTraded] = useState<any>()

    const [dayCurrencyDataListUnsold, setdayCurrencyDataListUnsold] = useState<any>()

    const [weekkWhDataListTraded, setweekkWhDataListTraded] = useState<any>()

    const [weekkWhDataListUnsold, setweekkWhDataListUnsold] = useState<any>()

    const [weekCurrencyDataListTraded, setweekCurrencyDataListTraded] = useState<any>()


    const [weekCurrencyDataListUnsold, setweekCurrencyDataListUnsold] = useState<any>()

    //------------------------

    const [yearkWhDataListTraded, setyearkWhDataListTraded] = useState<any>()

    const [yearkWhDataListUnsold, setyearkWhDataListUnsold] = useState<any>()

    const [yearCurrencyDataListTraded, setyearCurrencyDataListTraded] = useState<any>()

    const [yearCurrencyDataListUnsold, setyearCurrencyDataListUnsold] = useState<any>()

    let period24Data = productionDayData;
    let periodWeekData = productionWeekData;
    let periodYearData = productionYearData;

    // //get 24 hour period kWh Traded data 
    // const daykWhDataListTraded = period24Data.map((data) => data.usage.traded );
    // // get 24 hour period kWh Unsold data
    // const daykWhDataListUnsold= period24Data.map((data) => data.usage.unsold );
    // // get 24 hour period $ Traded data
    // const dayCurrencyDataListTraded = period24Data.map((data) => data.bill.traded );
    // // get 24 hour period $ Unsold Data
    // const dayCurrencyDataListUnsold= period24Data.map((data) => data.bill.unsold );

    // //get Week kWh Traded data 
    // const weekkWhDataListTraded = periodWeekData.map((data) => data.usage.traded );
    // // get Week kWh Unsold data
    // const weekkWhDataListUnsold= periodWeekData.map((data) => data.usage.unsold );
    // // get Week $ Traded data
    // const weekCurrencyDataListTraded = periodWeekData.map((data) => data.bill.traded );
    // // get Week $ Unsold Data
    // const weekCurrencyDataListUnsold= periodWeekData.map((data) => data.bill.unsold );

    // //get Year kWh Traded data 
    // const yearkWhDataListTraded = periodYearData.map((data) => data.usage.traded );
    // // get Year kWh Unsold data
    // const yearkWhDataListUnsold= periodYearData.map((data) => data.usage.unsold );
    // // get Year $ Traded data
    // const yearCurrencyDataListTraded = periodYearData.map((data) => data.bill.traded );
    // // get Year $ Unsold Data
    // const yearCurrencyDataListUnsold= periodYearData.map((data) => data.bill.unsold );


    let tradeData = daykWhDataListTraded;
    let unSoldData = daykWhDataListUnsold;
    // 24 hours period
    if (!isChecked && selectedDate === 'dst') {
        tradeData = daykWhDataListTraded;
        unSoldData = daykWhDataListUnsold;
    } else if (isChecked && selectedDate === 'dst') {
        tradeData = dayCurrencyDataListTraded;
        unSoldData = dayCurrencyDataListUnsold;
    }
    // Week
    else if (!isChecked && selectedDate === 'dsd') {
        tradeData = weekkWhDataListTraded;
        unSoldData = weekkWhDataListUnsold;
    } else if (isChecked && selectedDate === 'dsd') {
        tradeData = weekCurrencyDataListTraded;
        unSoldData = weekCurrencyDataListUnsold;
    }
    // Year
    else if (!isChecked && selectedDate === 'dsm') {
        tradeData = yearkWhDataListTraded;
        unSoldData = yearkWhDataListUnsold;
    } else if (isChecked && selectedDate === 'dsm') {
        tradeData = yearCurrencyDataListTraded;
        unSoldData = yearCurrencyDataListUnsold;
    }

    //get Labels 
    const daylabels = period24Data.map((data) => moment(data.startDate).format('H:mm'));
    const weeklabels = periodWeekData.map((data) => moment(data.startDate).format('DD MMM YY'));
    const yearlabels = periodYearData.map((data) => moment(data.endDate).format('MMM'));

    let labels = daylabels;

    if (selectedDate === 'dst') {
        labels = daylabels;
    }
    else if (selectedDate === 'dsd') {
        labels = weeklabels;
    }
    else if (selectedDate === 'dsm') {
        labels = yearlabels;
    }
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            const dayData = await getProductionData(moment(new Date(startDate)).format('YYYY-MM-DD'), 'd', 1)
            const weekData = await getProductionData(moment(new Date(startDate)).format('YYYY-MM-DD'), 'w', 1)
            const yearData = await getProductionData(moment(new Date(startDate)).format('YYYY-MM-DD'), 'y', 1)
            setProductionDayData(dayData.data)
            setProductionWeekData(weekData.data)
            setProductionYearData(yearData.data)
            setdaykWhDataListTraded(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.usage.traded
                }
            }))

            setdaykWhDataListUnsold(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.usage.unsold
                }
            }))
            setdayCurrencyDataListTraded(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.bill.traded
                }
            }))
            setdayCurrencyDataListUnsold(dayData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(startDate)).format('YYYY-MM-DD')) {
                    return item.bill.unsold
                }
            }))

            setweekkWhDataListTraded(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.usage.traded
                }
            }))
            setweekkWhDataListUnsold(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.usage.unsold
                }
            }))
            setweekCurrencyDataListTraded(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.bill.traded
                }
            }))
            setweekCurrencyDataListUnsold(weekData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(startDate)).format('YYYY-MM')) {
                    return item.bill.unsold
                }
            }))

            setyearkWhDataListTraded(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.usage.traded
                }
            }))
            setyearkWhDataListUnsold(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.usage.unsold
                }
            }))
            setyearCurrencyDataListTraded(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.bill.traded
                }
            }))
            setyearCurrencyDataListUnsold(yearData.data.map((item: any) => {
                if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(startDate)).format('YYYY')) {
                    return item.bill.unsold
                }
            }))
            setLoading(false)
        }
        fetchData()
        filterDate(new Date(startDate).toString())

    }, [startDate])

    const filterDate = (date: string) => {
        const daykWhDataListTradedArray = productionDayData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
                return item.usage.traded
            }
        })
        const daykWhDataListUnsoldArray = productionDayData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
                return item.usage.unsold
            }
        })

        const dayCurrencyDataListTradedArray = productionDayData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
                return item.bill.traded
            }
        })

        const dayCurrencyDataListUnsoldArray = productionDayData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD')) {
                return item.bill.unsold
            }
        })

        const weekkWhDataListTradedArray = productionWeekData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
                return item.usage.traded
            }
        })

        const weekkWhDataListUnsoldArray = productionWeekData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
                return item.usage.unsold
            }
        })

        const weekCurrencyDataListTradedArray = productionWeekData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
                return item.bill.traded
            }
        })

        const weekCurrencyDataListUnsoldArray = productionWeekData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY-MM') === moment(new Date(date)).format('YYYY-MM')) {
                return item.bill.unsold
            }
        })

        //----------------

        const yearkWhDataListTradedArray = productionYearData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
                return item.usage.traded
            }
        })


        const yearkWhDataListUnsoldArray = productionYearData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
                return item.usage.unsold
            }
        })


        const yearCurrencyDataListTradedArray = productionYearData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
                return item.bill.traded
            }
        })


        const yearCurrencyDataListUnsoldArray = productionYearData.map((item) => {
            if (moment(new Date(item.startDate)).format('YYYY') === moment(new Date(date)).format('YYYY')) {
                return item.bill.unsold
            }
        })


        setdaykWhDataListTraded(daykWhDataListTradedArray)
        setdaykWhDataListUnsold(daykWhDataListUnsoldArray)
        setdayCurrencyDataListTraded(dayCurrencyDataListTradedArray)
        setdayCurrencyDataListUnsold(dayCurrencyDataListUnsoldArray)
        setweekkWhDataListTraded(weekkWhDataListTradedArray)
        setweekkWhDataListUnsold(weekkWhDataListUnsoldArray)
        setweekCurrencyDataListTraded(weekCurrencyDataListTradedArray)
        setweekCurrencyDataListUnsold(weekCurrencyDataListUnsoldArray)
        setyearkWhDataListTraded(yearkWhDataListTradedArray)
        setyearkWhDataListUnsold(yearkWhDataListUnsoldArray)
        setyearCurrencyDataListTraded(yearCurrencyDataListTradedArray)
        setyearCurrencyDataListUnsold(yearCurrencyDataListUnsoldArray)


    }
    return (
        <div className='dashboardWidget'>
            <div className='widgetTitle'>
                <Row>
                    <Col md="5" sm="12" className='mb-3 mb-sm-0'>
                        <h3>Production</h3>

                        <label className='reactdatepicker-label' htmlFor="reactDatePicker">
                            <DatePicker
                                dateFormat={selectedDate === 'dst' ? "eeee, dd MMM ′yy" : selectedDate === 'dsd' ? "MMM ′yy" : "yyyy"}
                                selected={startDate}
                                className="datepicker"
                                id='reactDatePicker'
                                showMonthYearPicker={selectedDate === 'dsd' ? true : false}
                                showYearPicker={selectedDate === 'dsm' ? true : false}
                                onChange={date => date && setStartDate(date)}
                            />
                        </label>
                    </Col>
                    <Col md="7" sm="12">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='dateSelector border-end pe-4'>
                                <Form.Check type="radio" value="dst" id="dst" name='dateSelector' onChange={() => setSelectedDate('dst')} checked={selectedDate == 'dst' ? true : false} label="24" className='form-tag tag-primary' />
                                <Form.Check type="radio" value="dsd" id="dsd" name='dateSelector' onChange={() => setSelectedDate('dsd')} checked={selectedDate == 'dsd' ? true : false} label="D" className='form-tag tag-primary' />
                                <Form.Check type="radio" value="dsm" id="dsm" name='dateSelector' onChange={() => setSelectedDate('dsm')} checked={selectedDate == 'dsm' ? true : false} label="M" className='form-tag tag-primary' />
                            </div>
                            <div className='ps-4 switch d-flex align-items-center justify-content-end'>
                                <span className='d-block me-2'>kWh</span> <Form.Check type="switch" id="sbds" label="" onClick={() => setIsChecked(!isChecked)} /> <span className='d-block ms-2'>฿</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <div className='widgetBody'>
                {loading ? <DotLoader
                    color={color}
                    loading={loading}
                    cssOverride={override}
                    size={50}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                /> :
                    <ProductionChart treadeData={tradeData} unSoldData={unSoldData} isChecked={isChecked} labels={labels} />
                } </div>
        </div>
    )
}
export default AdminProduction;